import BackButton from '../components/BackButton';
import { useApp } from '../App';
import { useState, useEffect } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';
import { startImpersonation } from '../utils/impersonation';

export default function AdminCompanies() {
  const { user } = useApp();
  const { t } = useI18n();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', short_name: '', nip: '', krs: '', regon: '', address: '', legal_form: '' });
  const [msg, setMsg] = useState('');
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [baForm, setBaForm] = useState({ currency: 'PLN', iban: '', swift: '', bank_name: '', is_default: false });
  const [baMsg, setBaMsg] = useState('');

  const [jpkForm, setJpkForm] = useState({
    office_code: '', email: '', phone: '', country_code: 'PL',
    voivodeship: '', county: '', commune: '', street: '', house_number: '', apartment_number: '',
    city: '', postal_code: '', post_office: '', system_name: 'WORKIFYPL', prepared_by: ''
  });
  const [jpkMsg, setJpkMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const { data } = await api.get('/admin/companies');
      setCompanies(data);
    } catch {}
    setLoading(false);
  }

  async function create() {
    setMsg('');
    try {
      await api.post('/admin/companies', form);
      setMsg('✅ Фирма создана');
      setShowForm(false);
      load();
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function loadBankAccounts(companyId) {
    try {
      const { data } = await api.get(`/companies/${companyId}/bank-accounts`);
      setBankAccounts(data || []);
    } catch {}
  }

  async function loadJpkSettings(companyId) {
    try {
      const { data } = await api.get(`/jpk/admin/companies/${companyId}/settings`);
      if (data) setJpkForm({
        office_code: data.office_code || '',
        email: data.email || '',
        phone: data.phone || '',
        country_code: data.country_code || 'PL',
        voivodeship: data.voivodeship || '',
        county: data.county || '',
        commune: data.commune || '',
        street: data.street || '',
        house_number: data.house_number || '',
        apartment_number: data.apartment_number || '',
        city: data.city || '',
        postal_code: data.postal_code || '',
        post_office: data.post_office || '',
        system_name: data.system_name || 'WORKIFYPL',
        prepared_by: data.prepared_by || ''
      });
    } catch {}
  }

  async function saveJpkSettings() {
    if (!selectedCompany) return;
    setJpkMsg('');
    try {
      await api.put(`/jpk/admin/companies/${selectedCompany.id}/settings`, jpkForm);
      setJpkMsg('✅ JPK данные сохранены');
    } catch (e) { setJpkMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function validateJpkSettings() {
    if (!selectedCompany) return;
    setJpkMsg('');
    try {
      const { data } = await api.post(`/jpk/admin/companies/${selectedCompany.id}/validate`);
      if (data?.ok) setJpkMsg('✅ Все обязательные поля заполнены');
      else setJpkMsg('⚠️ Не заполнены: ' + (data?.missing || []).join(', '));
    } catch (e) { setJpkMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function createBankAccount() {
    if (!selectedCompany) return;
    setBaMsg('');
    try {
      await api.post('/admin/companies/bank-accounts', { ...baForm, company_id: selectedCompany.id });
      setBaMsg('✅ Счёт добавлен');
      setBaForm({ currency: 'PLN', iban: '', swift: '', bank_name: '', is_default: false });
      loadBankAccounts(selectedCompany.id);
    } catch (e) { setBaMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function deleteBankAccount(id) {
    try {
      await api.delete(`/admin/companies/bank-accounts/${id}`);
      loadBankAccounts(selectedCompany.id);
    } catch (e) { setBaMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  if (loading) return <Loading />;

  if (showForm) return (
    <div className="page"><BackButton />
      <h1>🏢 Новая фирма</h1>
      <div className="form">
        {[['name','Название'],['short_name','Сокращение'],['nip','NIP'],['krs','KRS'],['regon','REGON'],['address','Адрес'],['legal_form','Форма']].map(([k,l]) => (
          <div key={k} className="field"><label>{l}</label>
            <input value={form[k]} onChange={e => setForm({ ...form, [k]: e.target.value })} /></div>
        ))}
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={create}>✅ Создать</button>
        <button className="btn btn-secondary" onClick={() => setShowForm(false)}>{t('common.cancel')}</button>
      </div>
    </div>
  );

  return (
    <div className="page"><BackButton />
      <h1>🏢 Фирмы ({companies.length})</h1>
      <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ Добавить фирму</button>
      <div className="list">
        {companies.map(c => (
          <div key={c.id} className="list-item" onClick={() => { setSelectedCompany(c); loadBankAccounts(c.id); loadJpkSettings(c.id); }} style={{ cursor: 'pointer' }}>
            <div className="list-main">
              <div className="list-title">{c.short_name || c.name}</div>
              <div className="list-sub">NIP: {c.nip} | KRS: {c.krs || '—'}</div>
            </div>
            <div className={`status-badge status-${c.status}`}>{c.status}</div>
          </div>
        ))}
      </div>

      {selectedCompany && (
        <div className="card" style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>🏢 {selectedCompany.short_name || selectedCompany.name}</h3>
            <button
              className="btn btn-secondary btn-small"
              onClick={async () => {
                try {
                  const { data } = await api.post(`/admin/impersonate/company/${selectedCompany.id}`);
                  startImpersonation({
                    token: data.access_token || data.token,
                    mode: 'company_owner',
                    companyId: selectedCompany.id,
                    adminUser: user,
                  });
                  alert(`Вы вошли в компанию "${selectedCompany.name}" в owner-mode.`);
                  window.location.reload();
                } catch (e) {
                  alert(e.response?.data?.detail || 'Ошибка');
                }
              }}
            >
              🔑 Войти в компанию
            </button>
          </div>
          <h3>🏦 Счета — {selectedCompany.short_name || selectedCompany.name}</h3>
          {bankAccounts.length === 0 && <div className="empty">Счетов нет</div>}
          {bankAccounts.map(acc => (
            <div key={acc.id} className="list-item">
              <div className="list-main">
                <div className="list-title">{acc.currency} • {acc.bank_name || '—'}</div>
                <div className="list-sub">IBAN: {acc.iban} {acc.swift ? ' | SWIFT: ' + acc.swift : ''}</div>
              </div>
              <button className="btn btn-small" style={{ background: 'rgba(239,68,68,0.3)' }} onClick={() => deleteBankAccount(acc.id)}>{t('common.delete')}</button>
            </div>
          ))}

          <div className="form" style={{ marginTop: 12 }}>
            <div className="field"><label>Валюта</label><input value={baForm.currency} onChange={e => setBaForm({ ...baForm, currency: e.target.value.toUpperCase() })} /></div>
            <div className="field"><label>IBAN</label><input value={baForm.iban} onChange={e => setBaForm({ ...baForm, iban: e.target.value })} /></div>
            <div className="field"><label>SWIFT</label><input value={baForm.swift} onChange={e => setBaForm({ ...baForm, swift: e.target.value })} /></div>
            <div className="field"><label>Банк</label><input value={baForm.bank_name} onChange={e => setBaForm({ ...baForm, bank_name: e.target.value })} /></div>
          </div>
          {baMsg && <div className="message">{baMsg}</div>}
          <button className="btn btn-primary" onClick={createBankAccount}>+ Добавить счёт</button>
        </div>
      )}

      {selectedCompany && (
        <div className="card" style={{ marginTop: 16 }}>
          <h3>🧾 JPK Settings — {selectedCompany.short_name || selectedCompany.name}</h3>
          <div className="form">
            {[['office_code','Kod Urzędu'],['email','Email'],['phone','Telefon'],['voivodeship','Województwo'],['county','Powiat'],['commune','Gmina'],['street','Ulica'],['house_number','Nr domu'],['apartment_number','Nr lokalu'],['city','Miasto'],['postal_code','Kod pocztowy'],['post_office','Poczta']].map(([k,l]) => (
              <div key={k} className="field"><label>{l}</label>
                <input value={jpkForm[k]} onChange={e => setJpkForm({ ...jpkForm, [k]: e.target.value })} />
              </div>
            ))}
          </div>
          {jpkMsg && <div className="message">{jpkMsg}</div>}
          <div className="actions">
            <button className="btn btn-primary" onClick={saveJpkSettings}>💾 Сохранить</button>
            <button className="btn btn-secondary" onClick={validateJpkSettings}>✅ Проверить</button>
          </div>
        </div>
      )}
    </div>
  );
}
